import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../styles/Welcome.css';

function Welcome() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // الانتقال التلقائي بعد 3 ثواني
    const timer = setTimeout(() => {
      setIsLoading(false);
      setTimeout(() => {
        navigate('/home');
      }, 500);
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  const handleSkip = () => {
    setIsLoading(false);
    setTimeout(() => {
      navigate('/home');
    }, 500);
  };

  return (
    <motion.div 
      className="welcome-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: isLoading ? 1 : 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="welcome-content">
        <motion.div
          className="logo-container"
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ 
            duration: 1,
            type: "spring",
            stiffness: 100,
            damping: 10
          }}
        >
          <img src="/images/logo.png" alt="Fotomista" className="welcome-logo" />
        </motion.div>
        
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.6 }}
        >
          مرحباً بكم في فوتوميستا
        </motion.h1>
        
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.2, duration: 0.6 }}
        >
          تجربة تصوير احترافية لمناسباتكم الخاصة
        </motion.p>

        <motion.div
          className="loading-bar"
          initial={{ width: 0 }}
          animate={{ width: "100%" }}
          transition={{ duration: 3, ease: "linear" }}
        />

        <motion.button
          className="skip-button"
          onClick={handleSkip}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5 }}
        >
          تخطي
        </motion.button>
      </div>
    </motion.div>
  );
}

export default Welcome;